import { Paper } from '@mui/material'
import React, { useEffect } from 'react'

import MainTitle from "../../modules/shared/components/MainTitle"
import { useCadastraAssociado } from '../../modules/associado/hooks/useCadastraAssociado'
import FormCadastraAssociado from '../../modules/associado/components/FormCadastraAssociado/FormCadastraAssociado'
import { resetAssociado } from '../../store/reducers/associadoSlice'
import { resetAssociadoSelecionado } from '../../store/reducers/associadoSelecionadoSlice'
import { resetLocalizacao } from '../../store/reducers/localizacaoSlice'
import { resetOcorrencia } from '../../store/reducers/ocorrenciaSlice'
import { resetOcorrenciaSelecionada } from '../../store/reducers/ocorrenciaSelecionadaSlice'
import { resetUsuario } from '../../store/reducers/usuarioSlice'
import { useDispatch } from 'react-redux'
import { useDisplayAlertAfterServerResponseRedirectLogin } from '../../modules/shared/hooks/useDisplayAlertAfterServerResponseRedirectLogin/useDisplayAlertAfterServerResponseRedirectLogin'

export default function CadastrarAssociado() {
    
    const [resposta, cadastrarAssociado] = useCadastraAssociado()
    useDisplayAlertAfterServerResponseRedirectLogin(resposta)

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(resetAssociado())
        dispatch(resetAssociadoSelecionado())
        dispatch(resetLocalizacao())
        dispatch(resetOcorrencia())
        dispatch(resetOcorrenciaSelecionada())
        dispatch(resetUsuario())
    }, [dispatch])

    return (
        <Paper>
            <MainTitle titulo={"Cadastrar associado"} tituloPrincipal={true} />
            <FormCadastraAssociado aoSubmeterForm={cadastrarAssociado} editButton={true} />
        </Paper>
    )
}